module.exports = __webpack_public_path__ + "img/Boxenstop.9606d51c.svg";